import { render, staticRenderFns } from "./AdminSecrets.vue?vue&type=template&id=6a412b15&"
import script from "./AdminSecrets.vue?vue&type=script&lang=js&"
export * from "./AdminSecrets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports